// GTM dataLayer access. The GTM container itself is loaded first-party
// (from GTM_SOURCE, i.e. https://analytics.herbertseidl.at) in
// `plugins/gtm.client.ts` — this composable only pushes events onto the
// dataLayer queue, which the container drains once it has loaded.

function getDataLayer(): unknown[] {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  return w.dataLayer;
}

export function useDataLayer() {
  // The GTM dataLayer is untyped (`unknown[]`), so `push` accepts anything —
  // including the various typed `EventData` interfaces the call sites pass.
  const push = (...events: unknown[]): void => {
    // dataLayer only exists in the browser; on the server this is a no-op.
    if (!import.meta.client) return;
    getDataLayer().push(...events);
  };

  return { push };
}
